/* app/pages/homepage */

let sectorsHeroCtas;
const toggleClass = 'show-all';

var Homepage = {
	init: function ($elms) {
		sectorsHeroCtas = document.querySelectorAll('.js-sectors-hero-cta');

		Homepage._initEvents();
	},

	_initEvents: function () {
		// Add a click event listener to the sectorsHeroCtas elements
		sectorsHeroCtas.forEach(cta => {
			cta.addEventListener('click', Homepage._toggleCta);
		});
	},

	_toggleCta: function (event) {
		// Only run on mobile devices (screen width <= 768px)
		if (window.innerWidth > 768) {
			return;
		}

		event.preventDefault(); // Prevent the default action of the link
		const cta = event.currentTarget;
		const isExpanded = cta.getAttribute('aria-expanded') === 'true';

		// If setting to true, set 'aria-expanded' of other CTAs to 'false'
		if (!isExpanded) {
			/*const siblings = Array.from(cta.parentElement.children).filter(child => child !== cta);*/
			// If setting to true, set 'aria-expanded' of other CTAs to 'false'
			if (!isExpanded) {
				const wrapper = cta.closest('.c-sectors-hero__ctas-wrapper');
				const siblings = Array.from(wrapper.querySelectorAll('.js-sectors-hero-cta')).filter(el => el !== cta);
				siblings.forEach(sibling => sibling.setAttribute('aria-expanded', 'false'));
			}

			//siblings.forEach(sibling => sibling.setAttribute('aria-expanded', 'false'));
		}

		cta.setAttribute('aria-expanded', !isExpanded); // Toggle "aria-expanded" attribute
	}
};

export { Homepage };
